import Vue from 'vue'
import store from '@/store'
import get from 'lodash/get'
import CryptoJS from 'crypto-js'

const plugin = {
  install (Vue, options) {
    Vue.prototype.$notification = function (type, msg) {
      this.$notify({
        type,
        position: 'top-right',
        showClose: true,
        onClick: function () {
          this.close()
        },
        duration: 3000,
        title: this.$t('message.title'),
        message: msg || (type === 'success' ? this.$t('message.success') : this.$t('message.error'))
      })
    }
    Vue.prototype.$resetData = function () {
      Object.assign(this.$data, this.$options.data.apply(this))
    }
    Vue.prototype.$resetForm = function (form) {
      if (this.$refs[form]) {
        this.$nextTick(() => this.$refs[form].clearValidate())
      }
    }
    Vue.prototype.$validateForm = async function (form) {
      try {
        const valid = await this.$refs[form].validate().catch(() => {
          this.$message({ type: 'error', showClose: true, message: this.$t('message.ups') })
          return false
        })

        return Promise.resolve(valid)
      } catch (e) {
        return Promise.resolve(false)
      }
    }
    Vue.prototype.$getPermission = function (key, route) {
      if (route) {
        if ((key === 'crear' && route.indexOf('.editar') >= 0) || (key === 'modificar' && route.indexOf('.nuevo') >= 0)) {
          return false
        }
        key = `['${route.replace('purecloud.', '').replace('.ver', '').replace('.lista', '').replace('.nuevo', '').replace('.editar', '')}'].${key}`
      }

      return get(store.getters['auth/permissions'], key, false)
    }
    Vue.prototype.$encriptAES = function (data, llave) {
      const key = llave ? CryptoJS.enc.Utf8.parse(llave) : CryptoJS.enc.Utf8.parse('surveyatseucnesu')
      const srcs = CryptoJS.enc.Utf8.parse(JSON.stringify(data))
      return CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }).toString()
    }
    Vue.prototype.$decryptAES = function (data, llave) {
      const key = llave ? CryptoJS.enc.Utf8.parse(llave) : CryptoJS.enc.Utf8.parse('surveyatseucnesu')
      const decrypt = CryptoJS.AES.decrypt(data, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
      return CryptoJS.enc.Utf8.stringify(decrypt).toString()
    }
  }
}

Vue.use(plugin)
